import { motion, MotionProps } from 'framer-motion';
import React from 'react';

interface ConditionalMotionProps extends MotionProps {
  as?: keyof JSX.IntrinsicElements;
  animate?: boolean;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
  role?: string;
  'aria-labelledby'?: string;
  onClick?: () => void;
}

export const ConditionalMotion: React.FC<ConditionalMotionProps> = ({
  as = 'div',
  animate = true,
  children,
  className,
  style,
  id,
  role,
  'aria-labelledby': ariaLabelledBy,
  onClick,
  initial,
  whileInView,
  transition,
  viewport,
  whileHover,
  ...otherProps
}) => {
  const commonProps = {
    className,
    style,
    id,
    role,
    'aria-labelledby': ariaLabelledBy,
    onClick,
  };

  if (!animate) {
    // Return regular HTML element without animations
    return React.createElement(as, commonProps, children);
  }

  // Return motion component with animations
  const MotionComponent = motion[as as keyof typeof motion] as any;

  return (
    <MotionComponent
      {...commonProps}
      initial={initial}
      whileInView={whileInView}
      transition={transition}
      viewport={viewport}
      whileHover={whileHover}
      {...otherProps}
    >
      {children}
    </MotionComponent>
  );
};
